import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { getResidenceInformationRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getResidenceInformationRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    residentProvinceCode: "",
    residentDistrictCode: "",
    residentWardCode: "",
    residentWardName: "",
    residentDistrictName: "",
    residentProvinceName: "",
    residentAddress: "",
    stayingProvinceCode: "",
    stayingDistrictCode: "",
    stayingWardCode: "",
    stayingWardName: "",
    stayingDistrictName: "",
    stayingProvinceName: "",
    stayingAddress: "",
  },
};

const getResidenceInformationSlice = createSlice({
  name: "getResidenceInformation",
  initialState,
  reducers: {
    getResidenceInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getResidenceInformationSuccess: (
      state,
      action: PayloadAction<getResidenceInformationRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getResidenceInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetResidenceInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getResidenceInformationStart,
  getResidenceInformationSuccess,
  getResidenceInformationFailed,
  resetResidenceInformation,
} = getResidenceInformationSlice.actions;

export default getResidenceInformationSlice.reducer;
